// extracted by mini-css-extract-plugin
module.exports = {"container":"Details-module__container--3PAqS","noBottomBorder":"Details-module__noBottomBorder--3N6fR","textEnd":"Details-module__textEnd--37xhe"};